import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=1b477e32&"
import script from "./SearchGroup.vue?vue&type=script&lang=js&"
export * from "./SearchGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports